import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import { SERVER_URL } from "../../api/url";
import { Link, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import useStore from "../../store/information";


const RegisterForm = () => {
    const [error,setError]=useState("")
     const [message,setMessage]=useState("")
      const { Name,Id } = useStore();
  const initialValues = {
    name:"",
    email: "",
    password: "",
    phoneNumber:"",
    confirm_password:""
  };
    const navigate = useNavigate();

  const validationSchema = yup.object({
    name: yup.string().required("Name is required"),
    email: yup
      .string()
      .email("Invalid Email Format")
      .test("complete-domain", "Invalid Email Address", (value) => /@.+\..+/.test(value))
      .required("Email is required"),
phoneNumber: yup.number().required("Phone Number is required"),
    password: yup.string().required("Password is required"),
      confirm_password: yup.string().required("Confirm Password is required"),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
   

    const payload = {
      name:values.name,
      email: values.email,
      password: values.password,
      phoneNumber:`0${values.phoneNumber}`,
      confirm_password: values.confirm_password,
      notificationToken: "ee0YAt4iSDeaVJCmwTK1Dv:APA91bEiYWBswP4kiZT-z10-iSTQ_7l8VWQ52_wBpA2kWokTJW3AOG52kQkKyaTw8s41K-AfAJHkJOjC7nKeOkzaQ0-yF3jIxcS1eGIs27mIkbRQp3HkC5U",
    };

    try {
      const response = await axios.post(`${SERVER_URL}/auth/register`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.status === 200) {
        setMessage("Register Successfully")
        resetForm();
        const decoded = jwtDecode(response.data.data);
                 localStorage.setItem('userToken', response.data.data);
                   localStorage.setItem('userName', decoded.name);
                       localStorage.setItem('userEmail', decoded.email);
                       localStorage.setItem('userPhoneNumber', decoded.phoneNumber);
                       localStorage.setItem('userRole', decoded.role.name);
                       localStorage.setItem('userId', decoded._id);
     if(Name && Id){
 navigate('/payment', { state: { courseID:Id,courseName:Name } });
     }else{
         navigate("/")
     }
       
      } else {
         setError("Something Went Wrong,Please try again")
      }
    } catch (err) {
       setError(err.response?.data?.error)
    }

    setSubmitting(false);
  };

  return (
    <>
      <Toaster position="bottom-right" reverseOrder={false} />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        validateOnBlur={false}
        validateOnChange={false}
      >
        {({ isSubmitting }) => (
          <div className="react-blog-form">
            <h2 className="contact-title">
              Welcome <br /> Register to your account
            </h2>
            <div id="blog-form" className="blog-form">
              <Form id="contact-form">
                <div className="row">
                    <div className="col-lg-12">
                    <div className="back-input">
                      <Field name="name" type="text" placeholder="Your Name" />
                      <ErrorMessage className="errorComp" name="name" component="div" />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="back-input">
                      <Field name="email" type="email" placeholder="Email" />
                      <ErrorMessage className="errorComp" name="email" component="div" />
                    </div>
                  </div>

                   <div className="col-lg-12">
                    <div className="back-input">
                      <Field name="phoneNumber" type="number" placeholder="Phone Number" />
                      <ErrorMessage className="errorComp" name="phoneNumber" component="div" />
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="back-input">
                      <Field name="password" type="text" placeholder="Password" />
                      <ErrorMessage className="errorComp" name="password" component="div" />
                    </div>
                  </div>
                    <div className="col-lg-12">
                    <div className="back-input">
                      <Field name="confirm_password" type="text" placeholder="Confirm Password" />
                      <ErrorMessage className="errorComp" name="confirm_password" component="div" />
                    </div>
                  </div>
                    <h4 className="register-title" style={{display:"flex",justifyContent:"end"}}>
             Already have an account? <Link to="/login" > &nbsp;Login</Link>
            
            </h4>
                {message && (
          <div className="alert alert-info">
            {message}
           
          </div>
        )}
        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}
                  <div className="col-lg-12">
                    <button type="submit" className="back-btn" disabled={isSubmitting}>
                      {isSubmitting ? "Register..." : "Register"}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-arrow-right"
                      >
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </button>
                  </div>
            
                </div>
              </Form>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};

export default RegisterForm;
